<template>
    <section class="security-section bg-white container-global q-py-xl">
        <div class="security-container">
            <div class="security-text">
                <div class="security-title">أمان بياناتك أولويتنا</div>
                <div class="security-desc">نضمن حماية بياناتك باستخدام أحدث معايير الأمان والتشفير</div>
            </div>
            <div class="security-cards-row">
                <div class="security-card">
                    <img src="@/assets/images/new-home/security_3.svg" alt="إدارة آمنة وسرية تامة لبيانات العملاء"
                    class="security-icon" />
                    <div class="security-card-desc">بيانات مشفرة بأحدث المعايير</div>
                </div>
                <div class="security-card">
                    <img src="@/assets/images/new-home/security_2.svg" alt="نلتزم بحماية المعلومات الشخصية"
                    class="security-icon" />
                    <div class="security-card-desc">إدارة آمنة وسرية تامة لبيانات العملاء</div>
                </div>
                <div class="security-card">
                    <img src="@/assets/images/new-home/security_1.svg" alt="بيانات مشفرة بأحدث المعايير"
                        class="security-icon" />
                    <div class="security-card-desc">نلتزم بحماية المعلومات الشخصية</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
// No logic needed for this simple component
</script>

<style scoped lang="scss">
.security-section {
    width: 100%;
    margin: 40px auto 40px auto;
    display: flex;
    justify-content: center;
    background: #fff;
    padding: 64px 0;

}

.security-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 24px;
    gap: 32px;
    overflow: hidden;
}

.security-text {
    display: flex;
    
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 250px;
    margin-right: 32px;
}

.security-title {
    font-size: 2rem;
    font-weight: 700;
    color: var(--bs-text-color);
    margin-bottom: 12px;
}

.security-desc {
    color: var(--bs-text-color-secondary);
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 0;
}

.security-cards-row {
    display: flex;
    flex-direction: row-reverse;
    gap: 32px;
    justify-content: flex-end;
    align-items: center;
}

.security-card {
    background: #fff;
    border: 1.5px solid #EFEFF2;
    border-radius: 20px;
    box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.04);
    width: 260px;
    min-height: 120px;
    padding: 32px 70px 24px 40px;
    display: flex;
    flex-direction: column;
    transition: box-shadow 0.2s, border 0.2s;
}

.security-icon {
    width: 38px;
    height: 38px;
    margin-bottom: 16px;
}

.security-card-desc {
    font-size: 18px;
    color: var(--bs-text-color-secondary);
    font-weight: 500;
    margin-top: 0;
}

@media (max-width: 1100px) {
    .security-container {
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }

    .security-text {
        margin-right: 0;
        align-items: center;
        text-align: center;
    }

    .security-cards-row {
        flex-direction: column;
        gap: 18px;
        width: 100%;
        align-items: center;
    }

    .security-card {
        width: 90vw;
        max-width: 340px;
    }
}

</style>